import { useState, useCallback, useEffect, FC, ChangeEvent } from 'react';
import { axiosScraper } from '@utils/axios/axiosInstance';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import LoaderComponent from '@components/atom/layout/loader';
import { FadeLoader } from 'react-spinners';
import { gameProviderTypes } from '@configs/layout';
import { IResponseRegisteredAppInfo } from '@models/manager/service/serviceModel';
import ReactFlagsSelect from 'react-flags-select';
import { Countries2DigitCode } from '@models/commonModel';

interface IProps {
  selectedMyApp: IResponseRegisteredAppInfo; // provider_type 선택으로 인해 이게 필요함
  selectedCompetitorAppList: IResponseRegisteredAppInfo[];
  onClickSelectApp: (appObj: IResponseRegisteredAppInfo) => void;
}

const SearchAppList = ({ selectedMyApp, selectedCompetitorAppList, onClickSelectApp }: IProps) => {
  const { countryCode } = useSelector(({ serviceManager }: RootState) => serviceManager);
  const countriesArr = Countries2DigitCode.map((item) => item.code);
  const [selectedCountryCode, setSelectedCountryCode] = useState(countryCode);

  const [searchText, setSearchText] = useState('');

  const [searchListData, setSearchListData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const onChangeSearchText = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSearchText(value.trim());
  }, []);

  const onClickSearch = useCallback(async () => {
    if (searchText.trim().length === 0) {
      return alert('SearchText is Required, first');
    }
    setIsLoading(true);
    try {
      if (selectedMyApp?.provider_type === gameProviderTypes.GooglePlayStore) {
        const { data, status } = await axiosScraper.post('/google/search', {
          term: searchText,
          country: selectedCountryCode.toLowerCase(),
          num: 10,
        });
        console.log('Google Data: ', data);
        if (status === 200) {
          setSearchListData(data);
        }
      } else if (selectedMyApp?.provider_type === gameProviderTypes.AppleAppStore) {
        const { data, status } = await axiosScraper.post('/apple/search', {
          term: searchText,
          country: selectedCountryCode.toLowerCase(),
          num: 10,
        });
        console.log('Apple Data: ', data);
        if (status === 200) {
          setSearchListData(data);
        }
      }
    } catch (error) {
      alert(error);
    } finally {
      setIsLoading(false);
    }
  }, [selectedCountryCode, searchText, selectedMyApp]);

  const onSelectCountry = useCallback((code) => {
    setSelectedCountryCode(code);
  }, []);

  return (
    <div className="umanager-search">
      <h3 className="umanager-tit">Search Competitor Apps</h3>
      <div className="search-box type-1">
        <label className={`${searchText.trim().length > 0 ? 'active' : ''}`}>
          <input
            type="text"
            className="search-ipt"
            placeholder="Search Competitor Apps"
            value={searchText}
            onChange={onChangeSearchText}
          />
        </label>
        <ReactFlagsSelect
          selected={selectedCountryCode}
          onSelect={onSelectCountry}
          countries={countriesArr}
          searchable={true}
          showSelectedLabel={false}
          fullWidth={false}
        />
        <button
          type="button"
          className="search-btn"
          disabled={searchText.trim().length > 1 ? false : true}
          onClick={onClickSearch}
        >
          <span>SEARCH</span>
        </button>
      </div>
      <div className="umanager-result">
        {!isLoading && searchListData?.length > 0 && (
          <ul className="manager-list">
            {searchListData.map((appObj, index) => (
              <li key={appObj.appId}>
                <div className="manager-list-img">
                  <img src={appObj.icon} alt="" />
                </div>
                <div className="manager-list-txt">
                  <span className="manager-list-tit">{appObj.title}</span>
                  <span className="manager-list-dsc">{appObj.developer}</span>
                </div>
                <span className="manager-list-chk">
                  <input
                    type="checkbox"
                    className="ipt-check"
                    id={`checked-${appObj.appId}`}
                    checked={
                      selectedCompetitorAppList.findIndex((stateObj) => stateObj.appId === appObj.appId) > -1
                        ? true
                        : false
                    }
                    onChange={() => onClickSelectApp(appObj)}
                  />
                  <label htmlFor={`checked-${appObj.appId}`}>
                    <span className="blind">선택</span>
                  </label>
                </span>
              </li>
            ))}
          </ul>
        )}
        {isLoading && (
          <LoaderComponent height={'100px'}>
            <FadeLoader />
          </LoaderComponent>
        )}
      </div>
    </div>
  );
};

export default SearchAppList;
